import { useEffect, useState } from "react";

const navItems = [
  { href: "#process", label: "投稿流程" },
  { href: "#categories", label: "线索分类" },
  { href: "#cases", label: "爆料存档" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
  { href: "#contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-sm border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 cursor-pointer" aria-label="聚光台首页">
          <span
            className={`w-9 h-9 md:w-10 md:h-10 rounded-md flex items-center justify-center ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50 border border-background-50/40"
            }`}
          >
            <i className="ri-focus-3-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`font-heading text-lg md:text-xl tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              聚光台
            </strong>
            <span
              className={`text-[10px] md:text-xs tracking-[0.2em] ${
                solid ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              爆料线索中心
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-accent-300"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-fill"></i>
            匿名投稿
          </a>
          <button
            type="button"
            aria-label="展开导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
              solid
                ? "border-background-300 text-foreground-800"
                : "border-background-50/40 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200">
          <ul className="px-4 md:px-10 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-3 rounded-md text-sm text-foreground-800 hover:bg-background-100 cursor-pointer"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#submit"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
              >
                <i className="ri-send-plane-fill"></i>
                匿名投稿
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}